import { getAuth, type Auth } from 'firebase/auth';
import { firebaseApp } from './firebaseApp.js';

export const getFirebaseAuth = (): Auth | undefined => {
  if (!firebaseApp) return undefined;
  try {
    return getAuth(firebaseApp);
  } catch {
    return undefined;
  }
};

export const firebaseAuth = getFirebaseAuth();
